import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";

export function createIcon(Icon) {
	const WrappedIcon = ({ size, width, height, ...props }) => (
		<Icon
			{...(size !== undefined ? { width: size, height: size } : { width, height })}
			{...props}
		/>
	);

	WrappedIcon.displayName = Icon.displayName || Icon.name;

	WrappedIcon.propTypes = {
		size: PropTypes.oneOf(Object.values(ICON_SIZES)),
		width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	};

	return WrappedIcon;
}
